export { default } from './EventRegister'



// WEBPACK FOOTER //
// ./src/App/pages/EventRegistration/EventRegister/index.js